<template>
  <b-card no-body>
    <b-card-body class="p-1">
      <b-row class="mb-2">
        <b-col md="6" xl="3">
          <label>Desde</label>
          <b-input-group class="mb-1">
            <b-form-datepicker
              id="txtFechaInicio"
              v-model="txtFechaInicio"
              locale="es-ES"
            ></b-form-datepicker>
          </b-input-group>
        </b-col>

        <b-col md="6" xl="3">
          <label>Hasta</label>
          <b-input-group class="mb-1">
            <b-form-datepicker
              id="txtFechaFin"
              v-model="txtFechaFin"
              locale="es-ES"
            ></b-form-datepicker>
          </b-input-group>
        </b-col>
        <b-col md="12" xl="6"
          ><b-button
            variant="gradient-primary"
            size="xl"
            class="mt-2 float-right"
            :disabled="loading2"
            @click="traerEmpresas"
          >
            <feather-icon icon="FilterIcon" class="mr-50" />
            <span class="align-middle">Filtrar</span></b-button
          ></b-col
        >
      </b-row>
      <div class="d-flex justify-content-between flex-wrap">
        <!-- Registar Empresa  -->
        <b-form-group label-for="filterInput" class="mb-0">
          <b-button
            variant="gradient-primary"
            size="sm"
            class="mr-1"
            :disabled="loading2"
            @click="traerEmpresas"
          >
            <feather-icon icon="RefreshCwIcon" />
          </b-button>
          <b-button
            variant="gradient-primary"
            size="sm"
            :disabled="loading2"
            @click="descargarFile"
          >
            <span v-if="loading2">
              Generando Archivo..&emsp;<b-spinner
                style="width: 16px; height: 16px"
            /></span>
            <span v-else>
              <feather-icon icon="ExternalLinkIcon" class="mr-50" />
              <span class="align-middle">Exportar Excel</span>
            </span>
          </b-button>
        </b-form-group>
      </div>
    </b-card-body>

    <b-table
      hover
      responsive
      small
      class="position-relative"
      :per-page="perPage"
      :current-page="currentPage"
      :items="items"
      :fields="fields"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      :filter="filter"
      :filter-included-fields="filterOn"
      @filtered="cPaginacion"
      :busy="loading"
    >
      <template #table-busy>
        <div class="text-center text-dark my-1">
          <b-spinner class="align-middle"></b-spinner> &emsp;
          <strong>Obteniendo datos...</strong>
        </div>
      </template>
      <template #cell(estado)="data">
        <b-badge :variant="status[1][data.value]">
          {{ status[0][data.value] }}
        </b-badge>
      </template>
     <!--  <template #cell(fecha_creacion)="data">
        <span class="text-nowrap">
          {{
            new Date(data.value).toLocaleString("pe-PE", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              localeMatcher: "best fit",
              hour: "2-digit",
              minute: "2-digit",
              timeZone: "America/Lima",
            })
          }}
        </span>
      </template>
      <template #cell(fecha_exportacion)="data">
        <span class="text-nowrap">
          {{
            new Date(data.value).toLocaleString("pe-PE", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              localeMatcher: "best fit",
              hour: "2-digit",
              minute: "2-digit",
              timeZone: "America/Lima",
            })
          }}
        </span>
      </template> -->
      <template #cell(acciones)="data">
        <div class="text-nowrap">
          <feather-icon
            :id="`btn_${data.item.id}_ver`"
            icon="EyeIcon"
            size="16"
            class="mx-auto"
            @click="verFoto(data.item)"
          />
          <b-tooltip title="Ver foto" :target="`btn_${data.item.id}_ver`" />
        </div>
      </template>
    </b-table>

    <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
      <!-- page length -->
      <b-form-group
        label="Mostrar"
        label-cols="5"
        label-align="left"
        label-size="sm"
        label-for="sortBySelect"
        class="text-nowrap mb-md-0 mr-1"
      >
        <b-form-select
          id="perPageSelect2"
          v-model="perPage"
          size="sm"
          inline
          :options="pageOptions"
        />
      </b-form-group>

      <!-- pagination -->
      <div>
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          first-number
          last-number
          prev-class="prev-item"
          next-class="next-item"
          class="mb-0"
        >
          <template #prev-text>
            <feather-icon icon="ChevronLeftIcon" size="18" />
          </template>
          <template #next-text>
            <feather-icon icon="ChevronRightIcon" size="18" />
          </template>
        </b-pagination>
      </div>
    </b-card-body>
    <b-modal
      v-model="mostrarModalEditar"
      no-close-on-esc
      no-close-on-backdrop
      ok-only
      cancel-variant="secondary"
      cancel-title="Cerrar"
      size="md"
      centered
      title="Ver foto"
    >
      <div>
        <b-row>
          <b-col lg="12" class="text-center">
            <div v-if="!link" class="mt-2">
              <b-spinner label="Cargando..." variant="primary"></b-spinner>
              <p>Cargando imagen...</p>
            </div>
            <b-img v-else :src="link" fluid alt="Foto" />
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </b-card>
</template>

<script>
import axiosIns from "../../libs/axios";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import moment from "moment";
import {
  BCard,
  BTable,
  BAvatar,
  BBadge,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCardBody,
  BTooltip,
  BModal,
  VBModal,
  BListGroup,
  BListGroupItem,
  BRow,
  BCol,
  BSpinner,
  BInputGroupPrepend,
  BFormDatepicker,
  BImg,
} from "bootstrap-vue";

export default {
  components: {
    BCard,
    BTable,
    BAvatar,
    BBadge,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardBody,
    BTooltip,
    BModal,
    VBModal,
    BListGroup,
    BListGroupItem,
    BRow,
    BCol,
    vSelect,
    ToastificationContent,
    BSpinner,
    BInputGroupPrepend,
    BFormDatepicker,
    BImg,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  data() {
    return {
      txtFechaInicio: moment().format("YYYY-MM-DD"),
      txtFechaFin: moment().format("YYYY-MM-DD"),
      mostrarModalEditar: false,
      link: null,
      perPage: 15,
      pageOptions: [15, 25, 50],
      totalRows: 1,
      currentPage: 1,
      sortBy: "id",
      sortDesc: true,
      sortDirection: "desc",
      filter: null,
      filterOn: [],
      estadoModal: false,
      infoModal: {
        title: "",
        boton: "",
      },
      fields: [
        {
          key: "acciones",
          label: "Opciones",
          stickyColumn: true,
        },
        {
          key: "dni_reclutador",
          label: "DNI RECLUTADOR",
          sortable: true,
        },
        {
          key: "reclutador",
          label: "RECLUTADOR",
          sortable: true,
        },
        {
          key: "dni_hpw",
          label: "DNI HPW",
          sortable: true,
        },
        {
          key: "forma_vivienda",
          label: "FORMA VIVIENDA",
          sortable: true,
        },
        {
          key: "departamento",
          label: "DEPARTAMENTO",
          sortable: true,
        },
        {
          key: "provincia",
          label: "PROVINCIA",
          sortable: true,
        },
        {
          key: "distrito",
          label: "DISTRITO",
          sortable: true,
        },
        {
          key: "centro_poblado",
          label: "CENTRO POBLADO",
          sortable: true,
        },
        {
          key: "paradero",
          label: "PARADERO",
          sortable: true,
        },
        {
          key: "direccion",
          label: "DIRECCIÓN",
          sortable: true,
        },
        {
          key: "celular",
          label: "CELULAR",
          sortable: true,
        },
        {
          key: "whatsapp",
          label: "WHATSAPP",
          sortable: true,
        },
        {
          key: "realizar_llamada",
          label: "REALIZAR LLAMADA",
          sortable: true,
        },
        {
          key: "genero",
          label: "GÉNERO",
          sortable: true,
        },
        {
          key: "fecha_nacimiento",
          label: "FECHA NACIMIENTO",
          sortable: true,
        },
        {
          key: "con_hijos",
          label: "CON HIJOS",
          sortable: true,
        },
        {
          key: "nro_hijos",
          label: "N° HIJOS",
          sortable: true,
        },
        {
          key: "n_season_agv_arv",
          label: "N° CAMPAÑAS AGV-ARV",
          sortable: true,
        },
        {
          key: "gusto_principal",
          label: "GUSTO PRINCIPAL",
          sortable: true,
        },
        {
          key: "secreto_mejor_colaborador",
          label: "SECRETO MEJOR COSECHADOR",
          sortable: true,
        },
        {
          key: "que_falta_mejorar",
          label: "QUE FALTA PARA MEJORAR",
          sortable: true,
        },
        {
          key: "que_desearia_sorteen",
          label: "QUE DESARÍA QUE SORTEEN",
          sortable: true,
        },
        {
          key: "regresa_season",
          label: "REGRESA",
          sortable: true,
        },
        {
          key: "por_que_no_regresa",
          label: "POR QUÉ NO REGRESA",
          sortable: true,
        },
        {
          key: "que_rubro",
          label: "QUE RUBRO",
          sortable: true,
        },
        {
          key: "que_empresa",
          label: "QUE EMPRESA",
          sortable: true,
        },
        {
          key: "disponibilidad_retorno",
          label: "DISPONIBILIDAD DE RETORNO",
          sortable: true,
        },
        {
          key: "semana_mes_retorno",
          label: "SEMANA - MES DE RETORNO",
          sortable: true,
        },
        {
          key: "dni_lider",
          label: "DNI LIDER",
          sortable: true,
        },
        {
          key: "nombre_lider",
          label: "NOMBRE LIDER",
          sortable: true,
        },
        {
          key: "fecha_creacion_format",
          label: "FECHA DE CREACIÓN",
          sortable: true,
        },
        {
          key: "fecha_exportacion_format",
          label: "FECHA DE EXPORTACIÓN",
          sortable: true,
        },
        {
          key: "estado",
          label: "ESTADO",
          sortable: true,
        },
      ],
      items: [],
      status: [
        {
          0: "Inactivo",
          1: "Activo",
        },
        {
          0: "light-danger",
          1: "light-success",
        },
      ],
      validacion: null,
      estados: [
        { value: 0, text: "Inactivo" },
        { value: 1, text: "Activo" },
      ],
      codigo: "",
      descrip: "",
      nombre: "",
      estado: { value: 0, text: "Activo" },
      id: 0,
      tipo: 0,
      loading2: false,
      loading: false,
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({
          text: f.label,
          value: f.key,
        }));
    },
  },
  mounted() {
    this.traerEmpresas();
  },
  methods: {
    traerEmpresas() {
      var yo = this;
      yo.loading = true;

      var config = {
        method: "get",
        url: `/trabajaenagrovision/registrostea_movil/listar?fecha_inicio='${this.txtFechaInicio}'&fecha_fin='${this.txtFechaFin}'`,
      };

      axiosIns(config)
        .then(function (response) {
          yo.items = response.data.resultSet;
          yo.totalRows = yo.items.length;
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(function () {
          yo.loading = false;
        });
    },
    verFoto(datos) {
      this.mostrarModalEditar = true;
      this.link = null;
      var config = {
        method: "get",
        url: `/trabajaenagrovision/getfototea/?ruta=${datos.ruta_foto}`,
      };
      var yo = this;
      axiosIns(config)
        .then(function (response) {
          yo.link = response.data.resultSet;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    cPaginacion(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    mostrarNotificacion(titulo, icono, texto, variante) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: titulo,
            icon: icono,
            text: texto,
            variant: variante,
          },
        },
        {
          timeout: 5000,
        }
      );
    },

    descargarFile() {
      var yo = this;
      this.loading2 = true;
      var config = {
        method: "GET",
        url: `/trabajaenagrovision/registrostea_movil/exportar?fecha_inicio='${this.txtFechaInicio}'&fecha_fin='${this.txtFechaFin}'`,
        headers: {
          "Content-Type": "application/json",
        },
        responseType: "arraybuffer",
      };

      axiosIns(config)
        .then(function (response) {
          if (response.status === 200) {
            console.log("Enviado");
            console.log(response);
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement("a");
            fileLink.href = fileURL;
            fileLink.setAttribute("download", "RegistrosTEAMovil.xlsx");
            document.body.appendChild(fileLink);
            fileLink.click();

            yo.$toast(
              {
                component: ToastificationContent,
                props: {
                  title: "Archivo creado",
                  icon: "CheckIcon",
                  text: "El archivo se creó satisfactoriamente.",
                  variant: "success",
                },
              },
              {
                position: "top-center",
              }
            );
          } else if (response.status === 204) {
            yo.$toast({
              component: ToastificationContent,
              props: {
                title: "No existen registros",
                icon: "AlertTriangleIcon",
                text: "No se encontraron registros con los parámetros solicitados.",
                variant: "warning",
              },
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          yo.$toast({
            component: ToastificationContent,
            props: {
              title: "Error en la creación del archivo",
              icon: "XIcon",
              text: "Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.",
              variant: "danger",
            },
          });
        })
        .finally(function () {
          yo.loading2 = false;
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
